import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/dms/handle.svg'


const _withScopeId = n => (_pushScopeId("data-v-0319d5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title contents-title" }, "送信するファイル", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 削除 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "handle",
  src: _imports_0,
  alt: "ハンドル"
}, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "3",
    style: {"background-color":"#f7f7f7","text-align":"center"}
  }, "ファイルがアップロードされていません")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Table, {
      header: _ctx.header,
      className: 'contents'
    }, {
      default: _withCtx(() => [
        (_ctx.items.length !== 0)
          ? (_openBlock(), _createBlock(_component_draggable, {
              key: 0,
              modelValue: _ctx.items,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.items) = $event)),
              tag: "tbody",
              group: "file",
              "item-key": "name",
              handle: ".handle"
            }, {
              item: _withCtx(({ element, index }) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(element.fileName), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_AppButton, {
                      onClick: ($event: any) => (_ctx.deleteFile(index)),
                      onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.deleteFile(index)), ["prevent"]), ["space","enter"]),
                      buttonId: `button-delete-${index + 1}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 2
                    }, 1032, ["onClick", "onKeydown", "buttonId"]),
                    _hoisted_4
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_5, _hoisted_7))
      ]),
      _: 1
    }, 8, ["header"]),
    _hoisted_8
  ]))
}